<div class="row">
  <h2 class="h6 pb-5">{{ 'meterPoint.meterPointChangeRequest.newContractPartnerInfo' | translate }}</h2>
  @switch (contractPartnerType()) {
    @case (ContractPartnerType.PRIVATE) {
      <ikp-private-person-form />
    }
    @case (ContractPartnerType.COMPANY) {
      <ikp-organization-form />
    }
  }
</div>
